import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth'; // Your import
import '../App.css';

function Sidebar({ signOut }) {
  const location = useLocation();
  const [hasUploadAccess, setHasUploadAccess] = useState(false);

  useEffect(() => {
    async function checkUserAccess() {
      try {
        const user = await getCurrentUser();  // Fetch the current user
        if (user) {
          const attributes = await fetchUserAttributes(user);  // Fetch user attributes
        
          // Check if the email matches
          const allowedEmails = ['esther.flores.gon@gmail.com', 'hristina.popova@reachforchange.org', 'johanna.nilsson@reachforchange.org','andreaatoval@gmail.com', 'robertinshanghai@me.com'];
          setHasUploadAccess(allowedEmails.includes(attributes.email));
        }
      } catch (error) {
        console.log('Error fetching user details:', error);
      }
    }

    checkUserAccess();
  }, []);

  return (
    <div className="sidebar">
      <div>
        <button className="button button-sign-out" onClick={signOut}>👤  Sign Out</button>
      </div>
      <div>
        <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link>
        <Link to="/research" className={location.pathname === '/research' ? 'active' : ''}>Problem Analysis Assistant</Link>
        <Link to="/root" className={location.pathname === '/root' ? 'active' : ''}>Root Cause Analysis Assistant</Link>
        <Link to="/consequences" className={location.pathname === '/consequences' ? 'active' : ''}>Consequences Tracking Assistant</Link>
        <Link to="/interview" className={location.pathname === '/interview' ? 'active' : ''}>Interview Scripter</Link>
        <Link to="/survey" className={location.pathname === '/survey' ? 'active' : ''}>Survey Generator</Link>
        {hasUploadAccess && (
          <Link to="/upload-documents" className={location.pathname === '/upload-documents' ? 'active' : ''}>Upload Documents</Link>
        )}
        <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Link>
        
      </div>
      <div>
        <img src="https://rfc-info.s3.eu-north-1.amazonaws.com/rfc_white.png" alt="RFC Info" />
      </div>
    </div>
  );
}

export default Sidebar;